module.exports = __webpack_public_path__ + "static/media/cantonese_vocabulary_table_1.c33066cc.png";